import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

declare const ENVIRONMENT: string;
declare const VERSION: string;
declare const BRANCH: string;
declare const RELEASE: string;

function Copyright(): JSX.Element {
  const { t } = useTranslation();

  const environment = ENVIRONMENT;
  const appVersion = VERSION;
  const gitBranch = BRANCH;
  const release = RELEASE;

  return (
    <Typography
      variant="body2"
      color={'color.secondary'}
      align="center"
      sx={{
        mt: 5,
        mb: 1,
        ...(location.pathname === '/map' && {
          display: 'none',
        }),
      }}
    >
      {t('footer.copyright')}&nbsp;©&nbsp;<b>{new Date().getFullYear()}</b>&nbsp;|&nbsp;version:&nbsp;
      <b>{appVersion}</b>&nbsp;
      {environment === 'prod' ? null : (
        <>
          |&nbsp;env:&nbsp;<b>{environment}</b>&nbsp;|&nbsp;branch:&nbsp;<b>{gitBranch}</b>&nbsp;|&nbsp;release:&nbsp;
          <b>{release}</b>
        </>
      )}
    </Typography>
  );
}

export default Copyright;
